import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GlobalValidationService } from '../global-validation.service';

@Component({
  selector: 'app-icustomer-personal-details',
  templateUrl: './icustomer-personal-details.component.html',
  styleUrls: ['./icustomer-personal-details.component.scss']
})
export class IcustomerPersonalDetailsComponent implements OnInit {
  person_detail: FormGroup;
  icustomer_id: any;

  constructor(public dialogRef: MatDialogRef<IcustomerPersonalDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private httpService: HttpService, private global: GlobalService, private formBuilder: FormBuilder) {
    console.log(data)
    this.person_detail = this.formBuilder.group({
      first_name: [null, Validators.compose([Validators.required])],
      last_name: [null, Validators.compose([Validators.required])],
      mobile: [null, Validators.compose([Validators.required, GlobalValidationService.checkMobileNumber])],
    });
    this.icustomer_id = data['icustomer_id'];
    let data_dict = {
      'icustomer_id': data['icustomer_id']
    };
    this.httpService.serveIcustomerPersonalDeails(data_dict).subscribe((data) => {
      console.log(data);
      this.person_detail.get('first_name').setValue(data['first_name']);
      this.person_detail.get('last_name').setValue(data['last_name']);
      this.person_detail.get('mobile').setValue(data['mobile']);
    }, (error) => {
      console.error(error);
    });


  }

  updateCalled() {
    console.log(this.person_detail.value);
    let data_dict = {
      'form_data': this.person_detail.value,
      'icustomer_id': this.icustomer_id
    };
    this.httpService.updateIcustomerPersonalDeails(data_dict).subscribe((data) => {
      console.log(data);
      this.dialogRef.close(true);
    }, (error) => {
      console.error(error);
    });
  }

  closeComponent() {
    this.dialogRef.close(false);
  }

  ngOnInit() {
  }

}
